import { i18nGlobal } from "@/i18n"

export class CodiceFiscalePiva {
    /** Normalizza, accetta anche undefined/null/number ecc. */
    static normalize ( cf: unknown ): string {
        if ( cf == null ) return ''
        if ( typeof cf !== 'string' )
        {
            try { cf = String( cf ) } catch { return '' }
        }
        return ( cf as string ).replace( /\s/g, '' ).toUpperCase()
    }

    static format ( cf: unknown ): string {
        return this.normalize( cf )
    }

    static PRIVATE_validate_regular ( cf: string ): string | boolean {
        if ( !/^[0-9A-Z]{16}$/.test( cf ) ) return i18nGlobal.t( 'error.invalidCharacter' )
        let s = 0
        const even_map = 'BAFHJNPRTVCESULDGIMOQKWZYX'
        for ( let i = 0; i < 15; i++ )
        {
            const c = cf[ i ] as string
            let n = 0
            if ( '0' <= c && c <= '9' ) n = c.charCodeAt( 0 ) - '0'.charCodeAt( 0 )
            else n = c.charCodeAt( 0 ) - 'A'.charCodeAt( 0 )
            if ( ( i & 1 ) === 0 ) n = even_map.charCodeAt( n ) - 'A'.charCodeAt( 0 )
            s += n
        }
        if ( ( s % 26 ) + 'A'.charCodeAt( 0 ) !== cf.charCodeAt( 15 ) ) return i18nGlobal.t( 'error.invalidCheckSum' )
        return true
    }

    static PRIVATE_validate_temporary ( cf: string ): string | boolean {
        if ( !/^[0-9]{11}$/.test( cf ) ) return i18nGlobal.t( 'error.invalidCharacter' )
        let s = 0
        for ( let i = 0; i < 11; i++ )
        {
            let n = cf.charCodeAt( i ) - '0'.charCodeAt( 0 )
            if ( ( i & 1 ) === 1 )
            {
                n *= 2
                if ( n > 9 ) n -= 9
            }
            s += n
        }
        if ( s % 10 !== 0 ) return i18nGlobal.t( 'error.invalidCheckSum' )
        return true
    }

    static validateCF ( cf: unknown, mandatory = false ): string | boolean {
        const s = this.normalize( cf )
        if ( s.length === 0 ) return mandatory ? i18nGlobal.t( 'error.emptyValue' ) : true
        if ( s.length === 16 ) return this.PRIVATE_validate_regular( s )
        if ( s.length === 11 ) return this.PRIVATE_validate_temporary( s )
        return i18nGlobal.t( 'error.invalidLength' )
    }

    static validatePIVA ( piva: unknown, mandatory = false ): string | boolean {
        const s = this.normalize( piva )
        if ( s.length === 0 ) return mandatory ? i18nGlobal.t( 'error.emptyValue' ) : true
        if ( !/^[0-9]{11}$/.test( s ) ) return i18nGlobal.t( 'error.invalidLength' )
        return this.PRIVATE_validate_temporary( s )
    }
}
